var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.$style.bundle },
    _vm._l(_vm.itemImagesSorted, function(itemImage) {
      return _c("img", {
        key: itemImage.key,
        class: [_vm.$style.bundleItem, _vm.$style.animatedItemDown],
        style: itemImage.styles,
        attrs: { src: itemImage.url, alt: "" }
      })
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/apps/configurator/components/Preview/BundlePreview.vue?vue&type=template&id=f9361588&
// module id = null
// module chunks = 